import {
  Dropdown,
  PaginatedDropdownList,
  SequenceLead,
  sequencesAddLeadsCreateMutation,
  SequencesListData,
  sequencesListListInfiniteOptions
} from '@crm/api'
import { InfiniteSelect } from '@crm/components'
import { Properties } from '@crm/types'
import { useLocales } from '@shared/locales'
import { showApiErrors } from '@shared/utils'
import { useMutation } from '@tanstack/react-query'
import { App, Form, Modal } from 'antd'

import { useState } from 'react'

import type { ModalProps } from 'antd'

type Props = {
  leads?: number[]
  onClose: () => void
  onSubmit: () => void
} & ModalProps

const formName = 'add-campaign-leads'

export const CampaignsListForm = ({ leads, onClose, ...props }: Props) => {
  const { t } = useLocales()

  const [form] = Form.useForm()

  const [canSubmit, setCanSubmit] = useState(false)

  const { notification } = App.useApp()

  const onValuesChange = (field: SequenceLead) => {
    if (field) {
      setCanSubmit(true)
    }
  }

  const { mutate } = useMutation({
    ...sequencesAddLeadsCreateMutation(),
    onError: (error) => showApiErrors(error, form),
    onSuccess: (e: Properties) => {
      onClose()
      notification.success({
        message: t('success.success'),
        description: e.message
      })
    }
  })

  const onSubmit = ({ sequenceId }: { sequenceId: number }) => {
    if (leads) {
      mutate({ path: { id: sequenceId }, body: { leads } })
    }
  }

  return (
    <Modal
      title={t('lead.select_campaign')}
      onCancel={onClose}
      cancelText={t('buttons.cancel')}
      okText={t('buttons.add')}
      okButtonProps={{
        htmlType: 'submit',
        form: formName,
        disabled: !canSubmit
      }}
      {...props}
    >
      <Form
        name={formName}
        form={form}
        onValuesChange={onValuesChange}
        onFinish={onSubmit}
        layout="vertical"
      >
        <Form.Item name="sequenceId" label={t('campaigns.campaign')}>
          <InfiniteSelect<SequencesListData, PaginatedDropdownList, Dropdown>
            className="w-full"
            popupMatchSelectWidth
            getQueryFunction={sequencesListListInfiniteOptions}
            placeholder={t('main.select')}
          />
        </Form.Item>
      </Form>
    </Modal>
  )
}
